import styled from "styled-components";
import { Button } from "./Button";
import colors from "@styling/colors";
import { borderRadius, spacing } from "@styling/sizing";

const EMPTY_COLOR = "#ffffff";

const Row = styled.div`
  display: flex;
  align-items: center;
  gap: ${spacing.x2}px;
`;

const Swatch = styled.input`
  width: 48px;
  height: 36px;
  padding: 2px;
  border: 1px solid ${colors.border};
  border-radius: ${borderRadius.regular}px;
  background-color: ${colors.background};
  cursor: pointer;
`;

type ColorInputProps = {
  id?: string;
  value: string | null;
  onChange: (value: string | null) => void;
  onBlur?: () => void;
  clearLabel: string;
};

export const ColorInput = ({
  id,
  value,
  onChange,
  onBlur,
  clearLabel,
}: ColorInputProps) => (
  <Row>
    <Swatch
      id={id}
      type="color"
      value={value ?? EMPTY_COLOR}
      onChange={(e) => onChange(e.target.value)}
      onBlur={onBlur}
    />
    {value && (
      <Button
        type="button"
        $small
        $variant="outlined"
        $color="secondary"
        onClick={() => onChange(null)}
      >
        {clearLabel}
      </Button>
    )}
  </Row>
);
